/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import Accordion from 'components/Common/Accordion/Accordion'
import RadioFormItem from 'components/Common/ElementInForm/RadioFormItem';
import PopUpCustom from 'components/PopupCustom/PopUpCustom';
import { BtnCloseInModal } from 'components/Common/Button';

const OptionIsNoticeEmail = [
    { value: "1", label: "ส่ง" },
    { value: "0", label: "ไม่ส่ง" },
]

const CpnAlertEmail = (props) => {
    const {
        form,
        nStatusID,
        IsAllowEmailAlert,
        objPermission,
        sMode,
        sReferFrom,
        UserLoginBA = [],
    } = props;

    const [IsView, setIsView] = useState(false)
    const [IsOpenHelper, setIsOpenHelper] = useState(false)

    //Modify แยกมาจาก Detail 
    useEffect(() => {
        setIsView( ![0,1,2].includes(nStatusID) && (sMode === "view" || objPermission?.DetailCustomer?.isDisable == true))
        form.setValue("sNoticeEmail", IsAllowEmailAlert == true ? "1" : "0")
        
    }, [props.nStatusID, sMode])

    const onhandleOpenHelper = () => {
        setIsOpenHelper(!IsOpenHelper)
    }

    return (
        <>
            <Accordion header={"ข้อมูลการส่งอีเมลแจ้งเตือนลูกค้า (ข้อมูลใช้ภายใน)"} isShowHelper={true} onOpenHelper={onhandleOpenHelper}>
                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" style={{marginTop:'-20px'}}>
                    <Grid item xs={12} >
                        <RadioFormItem
                            name="sNoticeEmail"
                            label="ส่งอีเมลแจ้งเตือนลูกค้า"
                            required={ sReferFrom == "prd" || sReferFrom == "voc" ? true : (sReferFrom == "classify" ? (UserLoginBA.includes(parseInt(form.getValues("oBA")?.value)) ? true :  false) : false)}
                            options={OptionIsNoticeEmail}
                            value={form.getValues("sNoticeEmail")}
                            row={true}
                            IsNewLine={false}
                            disable={ sReferFrom == "classify" ? false : IsView}
                        // disable={sMode === "view" || [3, 4, 5,7,8, 19, 20].includes(nStatusID)}
                        />
                    </Grid>
                </Grid>
            </Accordion>
            <PopUpCustom
                setIsOpen={setIsOpenHelper}
                IsOpen={IsOpenHelper}
                sMaxWidth={'sm'}
                JsxDialogHeader={
                    <>
                        <Grid container direction="row" justifyContent="space-between" alignItems="center">
                            <Grid item>
                                <Typography>ข้อมูลเพิ่มเติม</Typography>
                            </Grid>
                            <Grid item>
                                <BtnCloseInModal txt={"ยกเลิก"} onClick={() => { onhandleOpenHelper() }} />
                            </Grid>
                        </Grid>
                    </>
                }
                JsxDialogContent={
                    <>
                        <Grid container spacing={1} direction="row" justifyContent="space-between" alignItems="center">
                            <Grid item xs={12}>
                                <Typography>- กรณีเลือกส่ง จะมีการแจ้งเตือนลูกค้าผ่านอีเมล</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography>- กรณีเลือกไม่ส่ง จะไม่มีการส่งแจ้งเตือนไปหาลูกค้าผ่านอีเมล</Typography>
                            </Grid>
                        </Grid>
                    </>
                }
            />
        </>
    )
}

export default CpnAlertEmail